<template>
  <div class="container text-center loading" v-if="!loaded">
      <img width="200" height="200" src="https://nkcreative.hu/assets/loading.svg"/>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: ['loaded', 'height']
}
</script>

<style scoped>
.loading{
  height:600px;
  padding-top:250px;

}
</style>



// WEBPACK FOOTER //
// src/components/Loading.vue